import { render } from "./CategoryHome.vue?vue&type=template&id=0dc56a0c"
import script from "./CategoryHome.vue?vue&type=script&lang=js"
export * from "./CategoryHome.vue?vue&type=script&lang=js"
script.render = render

export default script